import {Policy} from './PolicyConstants';

export default function getUserFacingPolicies<T extends Pick<Policy, 'isHidden'>>(
  policies: Array<T>
): Array<T> {
  return policies.filter((policy) => !policy.isHidden);
}
